var _rect, _rect2, _path, _rect3;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgUnsubscribing(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 48,
    height: 48,
    viewBox: "0 0 48 48",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 1.5,
    y: 1.5,
    width: 45,
    height: 45,
    rx: 22.5,
    fill: "white"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 1.5,
    y: 1.5,
    width: 45,
    height: 45,
    rx: 22.5,
    stroke: "#F25467",
    strokeWidth: 3
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M24 20.5833C27.1297 20.5833 29.6667 18.0463 29.6667 14.9167C29.6667 11.7871 27.1297 9.25 24 9.25C20.8704 9.25 18.3334 11.7871 18.3334 14.9167C18.3334 18.0463 20.8704 20.5833 24 20.5833ZM11.6414 31.9526C13.0427 27.0462 18.0445 23.4167 24.0001 23.4167C29.9556 23.4167 34.9574 27.0462 36.3587 31.9526C36.7884 33.4573 35.4815 34.75 33.9167 34.75H14.0834C12.5186 34.75 11.2117 33.4573 11.6414 31.9526Z",
    fill: "#51C0F0"
  })), _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
    x: 38.2778,
    y: 4.65039,
    width: 3,
    height: 48,
    transform: "rotate(40 38.2778 4.65039)",
    fill: "#F25467"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgUnsubscribing);
export default __webpack_public_path__ + "static/media/unsubscribing.1a5d066444f4d74b1b3d01c7aae1b42d.svg";
export { ForwardRef as ReactComponent };